/** Bật/tắt tính năng idle toàn app. Đặt `true` khi cần kích hoạt lại. */
export const IDLE_FEATURE_ENABLED = true;

/** Thời gian không tương tác trước khi chuyển sang trang idle (ms). */
export const IDLE_TIMEOUT_MS = 180 * 60 * 1000;

export const IDLE_RETURN_PATH_KEY = 'app-idle-return-path';
export const IDLE_ACTIVE_KEY = 'app-idle-active';
export const IDLE_LAST_ACTIVITY_KEY = 'app-idle-last-activity';

/** Tối thiểu giữa hai lần ghi lastActivity khi chỉ di chuyển chuột (ms). */
export const IDLE_ACTIVITY_THROTTLE_MS = 60_000;

/** Chu kỳ kiểm tra idle khi tab đang mở (ms). */
export const IDLE_CHECK_INTERVAL_MS = 180_000;

/**
 * Các route không chuyển sang `/idle` dù hết thời gian không tương tác.
 * Ví dụ: B5 Mô hình Xương cá — người dùng thường xem lâu không thao tác.
 */
export const IDLE_EXCLUDED_PATH_PREFIXES = ['/tenant-template', '/buoc5', '/b5-xuong-ca'] as const;
